import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConfirmActionInput } from '@website-builder/dialogs/confirm-action/model/confirm-action-input';
import { BaseDialog } from '@core/dialog/shared/models/base-dialog.interface';
import { DialogRef } from '@core/dialog/shared/utilities/dialog-ref';
import { DialogConfig } from '@core/dialog/shared/models/dialog-config';
import { ConfirmActionInputType } from '@website-builder/dialogs/confirm-action/model/confirm-action-input-type.enum';

@Component({
  selector: 'tess-confirm-action',
  imports: [CommonModule],
  templateUrl: './confirm-action.component.html',
  styleUrls: ['./confirm-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmActionComponent implements BaseDialog, OnInit {
  readonly #dialogRef = inject(DialogRef);
  readonly #dialogConfig = inject(DialogConfig);

  data: ConfirmActionInput;
  protected readonly ConfirmActionInputType = ConfirmActionInputType;

  ngOnInit(): void {
    this.data = this.#dialogConfig.data;
  }

  close(type: ConfirmActionInputType): void {
    this.#dialogRef.close(type);
  }
}
